import defaults from '../defaults';

export default class {
  constructor({ url, dealer, reviews, averageOverallStars }) {
    this.dealer = dealer;
    this.url = url;
    this.reviews = reviews;
    this.averageRating = averageOverallStars;
  }

  get isValid() {
    return Boolean(this.dealer.image);
  }

  toJSON() {
    if (!this.isValid) {
      return null;
    }

    const data = {
      '@type': 'http://schema.org/AutoDealer',
      id: this.url,
      name: this.dealer.display_name,
      telephone: this.dealer.phone_regional,
      aggregateRating: {
        '@type': 'http://schema.org/AggregateRating',
        ratingValue: this.averageRating,
        reviewCount: this.reviews.length,
      },
      address: {
        '@type': 'http://schema.org/PostalAddress',
        streetAddress: this.dealer.street,
        addressLocality: this.dealer.city,
        addressRegion: this.dealer.state,
        postalCode: this.dealer.zip,
      },
    };

    return { ...defaults, ...data };
  }
}
